import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Shows the table when the home page fails, including when its lazy chunk
 * can't load, so a flagged team never loses the list.
 */
export class RecordHomeErrorBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { hasError: boolean }
> {
  override state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      "Record home failed, showing the table:",
      error,
      errorInfo.componentStack,
    );
  }

  override render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
